import { render, staticRenderFns } from "./userMsg.vue?vue&type=template&id=2c00d084&"
import script from "./userMsg.vue?vue&type=script&lang=js&"
export * from "./userMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports